module.exports = __webpack_public_path__ + "static/media/calm_happy.0b5772f8.svg";